import { prefix } from '@goldwasserexchange/react-topmodel';
export var pPrefixer = prefix('P');
